/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { PlanVisibilitySettingsModel } from '../models/plan-visibility-settings-model';
import { UpdatePlanVisibilitySettingsCommandParams } from '../models/update-plan-visibility-settings-command-params';

@Injectable({ providedIn: 'root' })
export class PlanVisibilitySettingsApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPlanVisibilitySettings()` */
  static readonly GetPlanVisibilitySettingsPath = '/api/v1/plan-visibility-settings/{planVisibilitySettingsId}';

  /**
   * Get planVisibilitySettings per ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlanVisibilitySettings$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlanVisibilitySettings$Plain$Response(
    params: {
      planVisibilitySettingsId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlanVisibilitySettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, PlanVisibilitySettingsApiClient.GetPlanVisibilitySettingsPath, 'get');
    if (params) {
      rb.path('planVisibilitySettingsId', params.planVisibilitySettingsId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlanVisibilitySettingsModel>;
      })
    );
  }

  /**
   * Get planVisibilitySettings per ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlanVisibilitySettings$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlanVisibilitySettings$Plain(
    params: {
      planVisibilitySettingsId: number;
    },
    context?: HttpContext
  ): Observable<PlanVisibilitySettingsModel> {
    return this.getPlanVisibilitySettings$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlanVisibilitySettingsModel>): PlanVisibilitySettingsModel => r.body)
    );
  }

  /**
   * Get planVisibilitySettings per ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlanVisibilitySettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlanVisibilitySettings$Response(
    params: {
      planVisibilitySettingsId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlanVisibilitySettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, PlanVisibilitySettingsApiClient.GetPlanVisibilitySettingsPath, 'get');
    if (params) {
      rb.path('planVisibilitySettingsId', params.planVisibilitySettingsId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlanVisibilitySettingsModel>;
      })
    );
  }

  /**
   * Get planVisibilitySettings per ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlanVisibilitySettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlanVisibilitySettings(
    params: {
      planVisibilitySettingsId: number;
    },
    context?: HttpContext
  ): Observable<PlanVisibilitySettingsModel> {
    return this.getPlanVisibilitySettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlanVisibilitySettingsModel>): PlanVisibilitySettingsModel => r.body)
    );
  }

  /** Path part for operation `updatePlanVisibilitySettings()` */
  static readonly UpdatePlanVisibilitySettingsPath = '/api/v1/plan-visibility-settings/{planVisibilitySettingsId}';

  /**
   * Update planVisibilitySettings entry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlanVisibilitySettings$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePlanVisibilitySettings$Plain$Response(
    params: {
      planVisibilitySettingsId: number;
      body: UpdatePlanVisibilitySettingsCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlanVisibilitySettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, PlanVisibilitySettingsApiClient.UpdatePlanVisibilitySettingsPath, 'patch');
    if (params) {
      rb.path('planVisibilitySettingsId', params.planVisibilitySettingsId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlanVisibilitySettingsModel>;
      })
    );
  }

  /**
   * Update planVisibilitySettings entry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlanVisibilitySettings$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePlanVisibilitySettings$Plain(
    params: {
      planVisibilitySettingsId: number;
      body: UpdatePlanVisibilitySettingsCommandParams
    },
    context?: HttpContext
  ): Observable<PlanVisibilitySettingsModel> {
    return this.updatePlanVisibilitySettings$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlanVisibilitySettingsModel>): PlanVisibilitySettingsModel => r.body)
    );
  }

  /**
   * Update planVisibilitySettings entry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlanVisibilitySettings()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePlanVisibilitySettings$Response(
    params: {
      planVisibilitySettingsId: number;
      body: UpdatePlanVisibilitySettingsCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PlanVisibilitySettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, PlanVisibilitySettingsApiClient.UpdatePlanVisibilitySettingsPath, 'patch');
    if (params) {
      rb.path('planVisibilitySettingsId', params.planVisibilitySettingsId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlanVisibilitySettingsModel>;
      })
    );
  }

  /**
   * Update planVisibilitySettings entry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlanVisibilitySettings$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updatePlanVisibilitySettings(
    params: {
      planVisibilitySettingsId: number;
      body: UpdatePlanVisibilitySettingsCommandParams
    },
    context?: HttpContext
  ): Observable<PlanVisibilitySettingsModel> {
    return this.updatePlanVisibilitySettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlanVisibilitySettingsModel>): PlanVisibilitySettingsModel => r.body)
    );
  }

}
